import { FilterItem } from 'src/components/streametric/filters-bar';

type AssetFilterValue = {
  id: string;
};

/** Builds the alarms query string from the applied filters. */
export const parseAlarmFilters = (filter: FilterItem[]) => {
  const filters: string[] = [];

  const statusList: string[] = [];
  const priorityList: string[] = [];
  const alarmAcknowledgement: string[] = [];

  filter.forEach((filt) => {
    if (filt.name === 'time_frame') {
      filters.push('startDate=' + (filt!.value as string[])[0]);
      filters.push('endDate=' + (filt!.value as string[])[1]);
    }
    if (filt.group.name === 'alarm_type') {
      priorityList.push(filt.name);
    }
    if (filt.group.name === 'alarm_acknowledgement') {
      alarmAcknowledgement.push(filt.name);
    }
    if (filt.group.name === 'alarm_status' && filt.value === true) {
      statusList.push(filt.name);
    }

    if (filt.name === 'assets' && Array.isArray(filt.value)) {
      (filt.value as unknown as AssetFilterValue[]).forEach((et) =>
        filters.push('assetIdList=' + et.id)
      );
    }
  });

  if (alarmAcknowledgement.length === 1) {
    if (alarmAcknowledgement.includes('acknowledged')) {
      filters.push(`isAcknowledged=true`);
    } else {
      filters.push(`isAcknowledged=false`);
    }
  }

  if (priorityList.length) {
    priorityList.forEach((et) => filters.push(`priorityList=${et}`));
  }
  if (statusList.length) {
    statusList.forEach((et) => filters.push(`statusList=${et}`));
  }

  return filters.join('&');
};
